<template>
  <div v-bem>
    <component :is="titleElement" v-show="title" v-bem:title>
      {{ title }}
    </component>
    <slot v-if="rawContent" />
    <p v-else><slot /></p>
  </div>
</template>

<script>
export default {
  name: 'Panel',
  props: {
    title: {
      type: String,
      default: null,
    },
    rawContent: {
      type: Boolean,
      default: false,
    },
    titleElement: {
      type: String,
      default: 'h3',
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use "sass:map";

.panel {
  margin: 0 utils.f-rem-calc(-1 * utils.$v-wizard-gap-x);
  padding: utils.f-rem-calc(20) utils.f-rem-calc(utils.$v-wizard-gap-x);
  background-color: map.get(utils.$bs-theme-colors, 'secondary');
  line-height: 1.3em;
  margin-top: 2rem;

  > :last-child {
    margin-bottom: 0;
  }

  @at-root #{&}__title {
    font-size: utils.f-rem-calc(20);
    margin-bottom: utils.f-convert-to-rem(20);
    line-height: 1em;
  }
}
</style>
